import { LinearProgress } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    track: {
        flexShrink: 0,
        width: "8.18rem",
        height: ".5rem",
        borderRadius: ".25rem",
        backgroundColor: theme.palette.tailwind.slate[300],
    },
    fill: {
        borderRadius: ".25rem",
        backgroundColor: theme.palette.tailwind.green[600],
    },
}))

type Props = Readonly<{
    ready: number
    total: number
    className?: string
}>

export function ProductionProgressBar({ ready, total, className }: Props) {
    const { classes, cx } = useStyles()

    const percentage = total > 0 ? Math.round((ready / total) * 100) : 0

    return (
        <LinearProgress
            variant="determinate"
            value={percentage}
            className={cx(classes.track, className)}
            classes={{ bar: classes.fill }}
        />
    )
}
